import { createEntityMutation } from '@packages/api-client';
import { NotificationService } from '@wealthlane/api-services/wealthlane-notification-service';

export const useDeleteNotification = createEntityMutation<boolean, string>({
  mutationFn: (notificationId) =>
    NotificationService.deleteApiNotificationApiAppNotificationNotification(notificationId),
  invalidateKeys: ['getGetUnseenNotificationCountList', 'getGetUnseenNotificationList'],
});

export const useDeleteAllNotifications = createEntityMutation<boolean, void>({
  mutationFn: () =>
    NotificationService.deleteApiNotificationApiAppNotificationNotifications(),
  invalidateKeys: ['getGetUnseenNotificationCountList', 'getGetUnseenNotificationList'],
});
